import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { store } from '@maverick/store';
import { SourceApps } from '@maverick/entity';
import { createApiClient } from './client';

interface GetTransactionsHistoryByEmailParams {
    email: string;
}

export class LoyaltyService {
    private readonly apiClient;

    constructor(sourceApp: SourceApps) {
        this.apiClient = createApiClient(sourceApp);
    }

    async getTransactionsHistoryByEmail(params: GetTransactionsHistoryByEmailParams): Promise<RestResponse> {
        const auth0Token = store.getState().app.auth0Token;

        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `loyalty/transactions/${params.email}/history`,
            headers: {},
        });

        if (auth0Token) {
            request.headers = {
                authorization: `Bearer ${auth0Token}`,
            };
        }

        return await this.apiClient.ExecuteRequest(request);
    }
}
